/* eslint-disable jsx-a11y/control-has-associated-label */
import CardSummarySignature from 'components/atoms/card_summary_signature';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
  current_sale,
  getIncomes,
  get_scheduled_sale,
  has_pending_incomes,
} from 'store/modules/my_account_store/actions';
import { MyAccountState } from 'store/modules/my_account_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import Loader from 'components/atoms/loader';
import { Container } from './styles';

const MySignature = () => {
  const dispatch = useDispatch();

  const { my_account, request } = useSelector<ApplicationState, MyAccountState>(
    (state) => state.session.my_account,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    dispatch(current_sale());
    dispatch(get_scheduled_sale());
  }, []);

  useEffect(() => {
    my_account?.current_sale?.id !== 0 &&
      dispatch(has_pending_incomes(my_account?.current_sale?.id)) &&
      dispatch(getIncomes(my_account?.current_sale?.id));
  }, [my_account]);

  return (
    <Container>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                {request?.current_sale.loading ? (
                  <Loader />
                ) : (
                  <>
                    <div className="row">
                      <div className="col-md-12">
                        <h3 className="card-title py-2">
                          {profile?.company_data?.data?.razao_social}
                        </h3>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <p className="subtitle">
                          Assinatura:
                          <span className="font-weight-normal"> {profile?.sale_situation}</span>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p className="subtitle">
                          Serviço:
                          <span className="font-weight-normal">
                            {' '}
                            {profile?.paralyzed ? 'Inativo' : 'Ativo'}
                          </span>
                        </p>
                      </div>
                    </div>
                    <hr />
                    {my_account?.current_sale === null ? (
                      <div className="alert text-center">
                        Nenhuma assinatura vigente, acesse
                        <a href="/planos"> Planos e Preços</a> para realizar sua assinatura.
                      </div>
                    ) : (
                      my_account?.current_sale && (
                        <CardSummarySignature
                          title="Assinatura Atual"
                          valor_total={my_account?.current_sale?.valor_total}
                          inicio={my_account?.current_sale?.servicos_planos_vendas[0]?.inicio}
                          fim={my_account?.current_sale?.servicos_planos_vendas[0]?.fim}
                          paymentCondition={
                            my_account?.current_sale?.valor_variacao_forma_pagamento
                          }
                          parcela={my_account?.current_sale?.parcelas}
                          formas_pagamento={my_account?.current_sale?.formas_pagamento?.nome}
                          statusPayment={
                            my_account?.current_sale?.status_pagamento[0]?.receitas_pendentes
                          }
                          valorParcela={my_account?.valor_parcela}
                        />
                      )
                    )}
                    {my_account?.scheduled_sale !== null && my_account?.scheduled_sale && (
                      <CardSummarySignature
                        title="Assinatura agendada"
                        valor_total={my_account?.scheduled_sale?.valor_total}
                        inicio={my_account?.scheduled_sale?.servicos_planos_vendas[0]?.inicio}
                        fim={my_account?.scheduled_sale?.servicos_planos_vendas[0]?.fim}
                        paymentCondition={
                          my_account?.scheduled_sale?.valor_variacao_forma_pagamento
                        }
                        parcela={my_account?.scheduled_sale?.parcelas}
                        formas_pagamento={my_account?.scheduled_sale?.formas_pagamento?.nome}
                        statusPayment={
                          my_account?.scheduled_sale?.status_pagamento[0]?.receitas_pendentes
                        }
                        valorParcela={
                          Number(my_account?.scheduled_sale?.valor_total) /
                          Number(my_account?.scheduled_sale?.parcelas)
                        }
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default MySignature;
